import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyB4n8I2iDAiKYZAkhqWyhWZAEudNi9bLRw",
  authDomain: "femwellness-efa69.firebaseapp.com",
  projectId: "femwellness-efa69",
  storageBucket: "femwellness-efa69.firebasestorage.app",
  messagingSenderId: "787412396853",
  appId: "1:787412396853:web:fb4805ec9fbce42525fa7c"
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

export default app